import React from 'react';
import PropTypes from 'prop-types';

import RecommendationHeader from './Header';
import RecommendationContent from './Content';
import RecommendationFooter from './Footer';

const RecommendationContainer = ({
	data: { iconName, contentText, url, buttonText, mixPanelType, mixPanelContext }
}) => (
	<div className="re-recommendation-container re-container re-container-outer" data-testid="recommendation-container">
		<RecommendationHeader iconName={iconName} />
		<RecommendationContent contentText={contentText} />
		<RecommendationFooter
			url={url}
			buttonText={buttonText}
			mixPanelType={mixPanelType}
			mixPanelContext={mixPanelContext}
		/>
	</div>
);

RecommendationContainer.propTypes = {
	data: PropTypes.object.isRequired
};

export default RecommendationContainer;
